import React from 'react';
import usePoll from 'react-use-poll';
import puff from '../../puff.svg'
interface IProps {
    onPoll:()=>Promise<void>
}
export default function Poll(props: IProps) {
    usePoll(()=> {(async () => {
        await props.onPoll();
      })()},[],{
        interval: 2000
      });
    return <img src={puff} alt="puff" />;
}